import React,{useState,useEffect} from 'react'
import {Link} from 'react-router-dom';
import {Form,Button,Row,Col} from 'react-bootstrap';
import {useDispatch,useSelector} from 'react-redux';
import Message from '../components/Message'
import Loader from '../components/Loader'
import {login} from '../actions/userActions'
import FormContainer from '../components/FormContainer'
const LoginPage = ({location,history}) => { 
    const [email,setEmail] =useState()
    const [password,setPassword]=useState()

    const dispatch=useDispatch();
    const userLogin=useSelector(state=>state.userLogin);
    const {loading,error,userInfo}=userLogin;

    const redirect=location.search?location.search.split('=')[1]:'/' ;
    const onSubmit=(e)=>{
        e.preventDefault();
        dispatch(login(email,password))
    }

    useEffect(()=>{
        if(userInfo){
            history.push(redirect)
        }
    },[history,userInfo,redirect])
       return (
         <FormContainer>
           <h2>Login</h2>
           {error && (
             <Message variant="danger" message={error}>
               {error}
             </Message>
           )}
           {loading && <Loader />}
           <Form onSubmit={onSubmit}>
             <Form.Group controlId="email">
               <Form.Label>Email Address</Form.Label>
               <Form.Control
                 type="email"
                 placeholder="Enter email"
                 value={email}
                 onChange={(e) => setEmail(e.target.value)}
                 required
               ></Form.Control>
             </Form.Group>
             <Form.Group controlId="password">
               <Form.Label>Password</Form.Label>
               <Form.Control
                 type="password"
                 placeholder="Enter password"
                 value={password}
                 onChange={(e) => setPassword(e.target.value)}
                 required
               ></Form.Control>
             </Form.Group>
             <Button type="submit" variant="primary">
               Sign In
             </Button>
           </Form>
           <Row className="py-3">
             <Col>
               New Customer?{" "}
               <Link
                 to={redirect ? `/register?redirect=${redirect}` : "/register"}
               >
                 Register
               </Link>
             </Col>
           </Row>
         </FormContainer>
       );
}

export default LoginPage
